import React from "react";
import { Stack } from "@mui/material";
import DoorUI from "./DoorUI";
import DroneUI from "./DroneUI";

const DroneBox = React.memo((props) => {
  const {
    availableDrone = [],
    availableDoors = [],
    unavailableDrone = [],
    sx = {},
    clickBox = null,
    boxValue = null,
    available_drones = 0,
    available_doors = 0,
    unavailable_drones = 0,
    showUnAssignedDoorsEmpty = false,
    showUnAssignedDronesEmpty = false,
    showAvailableEmpty = false,
    showUnavailableEmpty = false,
    showDoorsEmpty = false,
    unAssignDoorsList = [],
    unAssignDronesList = [],
  } = props;

  return (
    <Stack direction={"row"} gap={1} sx={{ ...sx }}>
      <DroneUI
        clickBox={clickBox}
        boxValue={boxValue}
        status={"Available"}
        tooltip={"Available Drones"}
        showEmpty={showAvailableEmpty}
        value={availableDrone.length || available_drones}
      />
      <DroneUI
        clickBox={clickBox}
        boxValue={boxValue}
        status={"Unavailable"}
        tooltip={"Unavailable Drones"}
        showEmpty={showUnavailableEmpty}
        value={unavailableDrone.length || unavailable_drones}
      />
      <DroneUI
        clickBox={clickBox}
        boxValue={boxValue}
        status={"Unassigned Drones"}
        tooltip={"Unassigned Drones"}
        showEmpty={showUnAssignedDronesEmpty}
        value={unAssignDronesList.length || 0}
      />
      <DoorUI
        clickBox={clickBox}
        boxValue={boxValue}
        status={"Doors"}
        tooltip={"Available Doors"}
        showEmpty={showDoorsEmpty}
        value={availableDoors.length || available_doors}
      />
      <DoorUI
        clickBox={clickBox}
        boxValue={boxValue}
        status={"Unassigned Doors"}
        tooltip={"Unassigned Doors"}
        showEmpty={showUnAssignedDoorsEmpty}
        value={unAssignDoorsList.length || 0}
      />
    </Stack>
  );
});

export default DroneBox;
